import { createAsyncThunk } from '@reduxjs/toolkit';
import API_BASE_URL from '../../config/api';
import axios from 'axios';

export const fetchUserEntries = createAsyncThunk(
  'entries/fetchUserEntries',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth: { token } } = getState();
      if (!token) {
        return rejectWithValue('No authentication token, authorization denied');
      }
      const response = await axios.get(`${API_BASE_URL}/entries/user`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch entries');
    }
  }
);

export const checkDailyVisit = createAsyncThunk(
  'entries/checkDailyVisit',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth: { token } } = getState();
      if (!token) {
        return rejectWithValue('No authentication token, authorization denied');
      }
      const response = await axios.get(`${API_BASE_URL}/entries/check-daily-visit`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to check daily visit');
    }
  }
);
